import moment from 'moment';

export const HOLDS_ON_DATE_ATTRIBUTE = 'data-holds-on-date';
export const START_CHALLENGE_ATTRIBUTE = 'data-start-challenge';

export const holdDayKey = (hold) => `${moment(hold.start).format('YYYY-MM-DD')}|${hold.room_id}`;

const isActiveHold = (event) => (
  event.type === 'Hold' && !event.cleared_at && !event.converted_to_confirm_at
);

export const groupActiveHoldsByDay = (events) => events.reduce((groups, event) => {
  if (!isActiveHold(event)) return groups;

  const key = holdDayKey(event);
  groups.set(key, [...(groups.get(key) || []), event]);
  return groups;
}, new Map());

export const holdsOnDate = (holdsByDay, hold) => holdsByDay.get(holdDayKey(hold)) || [];

export const hasHoldAhead = (holdsByDay, hold) => (
  holdsOnDate(holdsByDay, hold).some((other) => other.position < hold.position)
);
